export default "__VITE_ASSET__BwmLhr_R__"